"use client";

import { useState, useRef, useEffect } from "react";

const BookmakerSelect21 = ({
  value,
  onChange,
  options,
  placeholder = "",
  className = "",
  triggerClassName = "",
  icon,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => String(o.value) === String(value));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <div
      className={`relative block lg:inline-block min-w-0 lg:flex-shrink-0 ${className}`}
      ref={ref}
    >
      <div
        className={`flex items-center gap-1 lg:gap-2 px-1.5 py-2 lg:px-3 lg:py-[9px] bg-white border [border-style:solid] border-[#E5E7EB] rounded-[6px] text-[#374151] text-[11px] lg:text-[13px] font-semibold cursor-pointer select-none transition-all hover:border-gray-300 w-full min-w-0 lg:min-w-[130px] appearance-none outline-none box-border ${triggerClassName}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        {icon && <div className="flex shrink-0 items-center justify-center scale-90 lg:scale-100">{icon}</div>}
        <span className="flex-1 text-left truncate">{selected ? selected.label : placeholder}</span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`shrink-0 text-gray-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        >
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </div>
      {open && (
        <ul className="absolute left-0 top-full mt-1.5 min-w-full max-h-[300px] overflow-y-auto rounded-xl bg-white shadow-2xl border border-gray-100 z-[9999] list-none m-0 p-1.5 animate-in fade-in slide-in-from-top-2 duration-200">
          {options.map((item) => {
            const isSelected = String(item.value) === String(value);
            return (
              <li
                key={item.value}
                className={`px-3 py-2 text-[13px] font-semibold cursor-pointer rounded-lg transition-all mb-0.5 last:mb-0 ${isSelected
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-600 hover:bg-gray-50 hover:text-blue-600"
                  }`}
                onClick={() => handleSelect(item.value)}
              >
                <div className="flex items-center justify-between">
                  <span>{item.label}</span>
                  {isSelected && <span className="text-blue-600 text-xs">✓</span>}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default BookmakerSelect21;
